'use client';
import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import BannerSectionStyle4 from '../Section/BannerSection/BannerSectionStyle4';
import Section from '../Section';
import DepartmentSectionStyle2 from '../Section/DepartmentSection/DepartmentSectionStyle2';
import FeaturesSectionStyle2 from '../Section/FeaturesSection/FeaturesSectionStyle2';
import FunFactSection from '../Section/FunFactSection';
import TeamSection from '../Section/TeamSection';
import GallerySection from '../Section/GallerySection';
import AwardSectionStyle2 from '../Section/AwardSection/AwardSectionStyle2';
import { pageTitle } from '../../helpers/PageTitle';
const departmentData = [
  {
    title: 'Prosthetic Fittings & Fabrication',
    subTitle:
      'Custom-built prosthetic limbs tailored to each patient’s lifestyle, goals, and anatomy for the best fit and function.',
    iconUrl: 'images/icons/comprehensive.svg',
    /* href: '/departments/department-details', */
  },
  {
    title: 'Orthotic Bracing Solutions',
    subTitle:
      'Supportive and corrective orthotic devices designed for injury recovery, mobility assistance, or preventative care.',
    iconUrl: 'images/icons/facilities.svg',
    /* href: '/departments/department-details', */
  },
  {
    title: 'Follow-Up & Adjustments',
    subTitle:
      'We provide ongoing adjustments and maintenance to ensure long-term comfort and usability of each device.',
    iconUrl: 'images/icons/calendar_white.svg',
    /* href: '/departments/department-details', */
  },
  {
    title: 'Pediatric & Geriatric Care',
    subTitle:
      'Specialized prosthetic and orthotic care for children, seniors, and those with unique or evolving needs.',
    iconUrl: 'images/icons/patient.svg',
    /* href: '/departments/department-details', */
  },
  {
    title: 'Veteran & First Responder Support',
    subTitle:
      'Proudly serving military veterans and emergency responders with dedicated care and community-focused solutions.',
    iconUrl: 'images/icons/professional.svg',
    /* href: '/departments/department-details', */
  },
];

const featureListData = [
  {
    title: 'Personalized <br />Care & Support',
    subTitle:
      'We walk alongside each patient throughout <br />their journey—from first consultation to follow-up—<br />offering compassionate, ongoing support.',
    iconUrl: 'images/icons/comprehensive.svg',
  },
  {
    title: 'Quality Materials & Craftsmanship',
    subTitle:
      'Our prosthetics and orthotics are made from <br />high-grade materials with precise fitting and <br />development for long-lasting comfort and function.',
    iconUrl: 'images/icons/professional.svg',
  },
  {
    title: 'Realistic Goal Setting',
    subTitle:
      'We collaborate with patients to define <br />achievable goals, focusing on restoring function <br />and independence in everyday life.',
    iconUrl: '/images/icons/calendar_white.svg',
  },
  {
    title: 'Lasting Patient Relationships',
    subTitle:
      'Unlike large corporate providers, we invest in <br />building trust and relationships that extend <br />beyond treatment.',
    iconUrl: 'images/icons/patient.svg',
  },
];

const funFactData = [
  { number: '70+', title: 'Years of combined experience' },
  { number: '100%', title: 'Dedicated professional staff' },
  { number: '100+', title: 'Veterans and first responders served' },
];

/* const teamData = [
  {
    imgUrl: 'images/about/doctor_1.png',
    name: 'David Bryan Jr.',
    designation: 'BOCP, Owner at Freedom Prosthetics LLC',
    description:
      'A board-certified prosthetist dedicated to continuing his father’s legacy of compassionate, patient-centered care. David Jr. specializes in advanced prosthetic solutions and leads the Freedom team with innovation and heart.',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      {
        icon: 'fa6-brands:linkedin-in',
        href: 'https://www.linkedin.com/in/david-bryan-b1462090/',
      },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
  },
  {
    imgUrl: 'images/about/doctor_2.png',
    name: 'Dr. John Smith, MD',
    designation: 'Emergency Medicine Physician',
    description:
      'With expertise in treating acute illnesses and injuries in medicine physician',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
  },
  {
    imgUrl: 'images/about/doctor_3.png',
    name: 'Dr. Susan Bones, MD',
    designation: 'Board-certified Pediatrician',
    description:
      'With experience in managing complex medical conditions in children',
    social: [
      { icon: 'fa6-brands:facebook-f', href: '/about' },
      { icon: 'fa6-brands:linkedin-in', href: '/about' },
      { icon: 'fa6-brands:twitter', href: '/about' },
    ],
  },
]; */

const galleryData = [
  { imgUrl: '/images/about/portfolio_2_lg.png' },
  { imgUrl: '/images/about/portfolio_3_lg.png' },
  { imgUrl: '/images/about/portfolio_1_lg.png' },
  { imgUrl: '/images/about/portfolio_4_lg.png' },
  { imgUrl: '/images/about/portfolio_5_lg.png' },
];
const awardData = [
  {
    iconUrl: '/images/icons/award.svg',
    title: '8+ Years of Dedicated Service',
  },
  {
    iconUrl: '/images/icons/award.svg',
    title: '100+ Veterans and First Responders Helped',
  },
  {
    iconUrl: '/images/icons/award.svg',
    title: '70+ Years of Combined Clinical Experience',
  },
  {
    iconUrl: '/images/icons/award.svg',
    title: 'Proudly Locally-Owned and Operated',
  },
];

export default function About() {
  pageTitle('About');

  const [teamData, setTeamData] = useState([]);

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'teamData'));
        const team = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            name: data.name,
            designation: data.designation,
            description: data.description,
            imgUrl: data.imgUrl,
            social: [
              { icon: 'fa6-brands:facebook-f', href: data.facebook || '#' },
              { icon: 'fa6-brands:linkedin-in', href: data.linkedin || '#' },
              { icon: 'fa6-brands:twitter', href: data.twitter || '#' },
            ],
          };
        });
        setTeamData(team);
      } catch (error) {
        console.error('Error fetching staff:', error);
      }
    };

    fetchTeam();
  }, []);

  return (
    <>
      <BannerSectionStyle3
        bgUrl='/images/about/banner_bg.svg'
        imgUrl='/images/about/banner_img.png'
        title='Welcome to <br />Freedom Prosthetics & Orthotics'
        subTitle='Restoring Mobility. Rebuilding Confidence.'
      />
      <Section topMd={200} topLg={150} topXl={110}>
        <DepartmentSectionStyle2
          sectionTitle='What We Offer'
          sectionTitleUp='SERVICES'
          data={departmentData}
        />
      </Section>
      <Section topMd={175} topLg={125} topXl={85} bottomMd={100} bottomLg={110}>
        <FeaturesSectionStyle2
          sectionTitle='What Sets Us Apart'
          imgUrl='images/about/why_choose_us.png'
          data={featureListData}
        />
      </Section>
      <Section>
        <FunFactSection
          bgUrl='images/about/fun_fact_bg.jpeg'
          data={funFactData}
        />
      </Section>

      <Section topMd={190} topLg={145} topXl={105}>
        <div className='david-article-section'>
          <div className='max-w-4xl mx-auto px-4 text-gray-800 leading-relaxed'>
            <h2 className='text-4xl font-bold text-primary mb-6 text-center'>
              Company History
            </h2>
            <p className='mb-5'>
              <strong>Freedom Prosthetics, LLC</strong> has provided quality
              care for over 8 years, backed by more than 50 years of combined
              experience in orthotics and prosthetics. We proudly serve patients
              with artificial limbs and braces at our Walker, Louisiana
              facility. Our location is 9354 Florida Boulevard, Walker, LA
              70785. The business and after-hours phone number is (225)
              665-0323.
            </p>

            <h2 className='text-4xl font-bold text-primary mt-10 mb-6 text-center'>
              Mission Statement
            </h2>
            <p className='mb-5'>
              Our mission is simple: to work alongside patients as they regain
              the freedom to achieve their functional goals with prosthetic
              and/or orthotic devices. From the moment a patient enters our
              facility to long after they leave, we are committed to providing
              support and care.
            </p>
            <p className='mb-5'>
              Unlike larger, more impersonal providers,{' '}
              <strong>Freedom Prosthetics, LLC</strong> strives to build lasting
              relationships with our patients. We use high-quality materials,
              take time with development and fittings, and engage patients in
              realistic goals. Our objective is to meet—and often exceed—patient
              expectations through personalized attention and service.
            </p>
          </div>
        </div>
      </Section>

      {/* Dynamic Team Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <TeamSection
          sectionTitle='Experts Staff'
          sectionTitleUp='MEET OUR'
          data={teamData}
        />
      </Section>

      {/*       <Section topMd={190} topLg={145} topXl={105}>
        <TeamSection
          sectionTitle='Experts Doctor'
          sectionTitleUp='MEET OUR'
          data={teamData}
        />
      </Section> */}

      <Section topMd={190} topLg={145} topXl={105}>
        <div className='max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-start gap-12'>
          {/* Image Column */}
          {/* <div className='w-full lg:w-1/2'>
            <img
              src='/images/about/david_journey.png'
              alt='David Bryan Sr'
              className='rounded-lg shadow-lg w-full object-cover'
            />
          </div> */}

          {/* Text Column */}
          <div className='w-full lg:w-1/2 text-gray-800 leading-relaxed'>
            <h2 className='text-4xl font-bold text-primary mb-8 text-center lg:text-left'>
              The Impossible Dream: David Bryan Sr’s Journey
            </h2>

            <blockquote className='italic text-gray-600 mb-8 border-l-4 border-blue-500 pl-6 text-lg'>
              “I think that one of these days,” he said. “You’re going to have
              to find out where you want to go. And then you’ve got to start
              going there. But immediately. You can’t afford to lose a minute.
              Not you.”
              <br />
              <span className='block mt-4 text-sm font-semibold text-right'>
                — J.D. Salinger, <em>The Catcher in the Rye</em>
              </span>
            </blockquote>

            <p className='mb-5'>
              David Bryan has known where he wanted to go for years. His
              dream—to help others through prosthetic care—was born from
              personal experience but seemed, at times, insurmountable.
            </p>
            <p className='mb-5'>
              The youngest of 22 children, David was born with a reverse club
              foot that required amputation when he was just 18 months old.
              Growing up with an artificial limb, economic hardship, and
              emotional adversity, his childhood dream of working in a
              prosthetics clinic felt more and more distant.
            </p>
            <p className='mb-5'>
              “Even at age 11, I knew I wanted to be in a place where I could
              help others who were going through the same things I had gone
              through,” David said. “When I finally got old enough to start
              looking for that place, it seemed as if I was going to be looking
              all my life.”
            </p>
            <p className='mb-5'>
              After a few unfulfilling jobs and years of discouragement, David's
              opportunity finally arrived when Doyle Sims, a certified
              orthopedic prosthetist in Jackson, took a chance on him. Through
              the Private Sector Initiative Program and the Comprehensive
              Employment Training Act (CETA), David began training at Sims
              Prosthetics and Orthopedic Appliance.
            </p>
            <p className='mb-5'>
              The CETA program, administered by the Governor’s Office of Job
              Development and Training, gave employers tax benefits and wage
              support to train individuals in real job environments.
            </p>
            <p>
              Today, David brings that same determination and compassion to
              Freedom Prosthetics & Orthotics—empowering patients with not only
              technology, but true understanding.
            </p>
          </div>
        </div>
      </Section>

      <Section topMd={170} topLg={120} topXl={80}>
        <GallerySection
          sectionTitle='Our Facilities and <br />Latest Activities'
          sectionTitleUp='HAVE A LOOK AT'
          data={galleryData}
        />
      </Section>
      <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <AwardSectionStyle2
          sectionTitle='Serving Those Who Served<br />With Heart and Precision'
          sectionTitleUp='SERVICE RECORD'
          sectionSubTitle='From veterans to first responders, we’ve helped hundreds regain mobility and confidence with personalized prosthetic care.'
          data={awardData}
        />
      </Section>
      <Section className='cs_footer_margin_0'>
        <BannerSectionStyle4
          bgUrl='images/about/banner_bg_2.png'
          title='Don’t Let Your Health <br />Take a Backseat!'
          subTitle='Schedule an appointment with one of our experienced <br />medical professionals today!'
          center
        />
      </Section>
    </>
  );
}
